import { SUBCATEGORIES } from '../../common/categories';

const {
    DUO_MFA_TOKEN,
    RSA_MFA_TOKEN,
    OKTA_MFA_TOKEN,
    PING_MFA_TOKEN,
    MICROSOFT_MFA_TOKEN,
    HYPR_MFA_TOKEN,
    FIDO2_MFA_TOKEN,
    ENTRA_ID_MFA_TOKEN
} = SUBCATEGORIES;

export const MFA_TOKEN_TO_TEST_FACTOR = {
    [DUO_MFA_TOKEN.ID]: 'duo',
    [RSA_MFA_TOKEN.ID]: 'rsa',
    [OKTA_MFA_TOKEN.ID]: 'okta',
    [PING_MFA_TOKEN.ID]: 'ping',
    [MICROSOFT_MFA_TOKEN.ID]: 'microsoft',
    [HYPR_MFA_TOKEN.ID]: 'hypr',
    [FIDO2_MFA_TOKEN.ID]: 'fido2',
    [ENTRA_ID_MFA_TOKEN.ID]: 'entraId'
};
